export default "__VITE_PUBLIC_ASSET__6eebe8ab__"